import type { DataPoint } from "@foodpilot/foods";
import type { ActionPlanCampaigns } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq";

type Options = Omit<ActionPlanCampaigns, "current"> & {
    current?: ActionPlanCampaigns["current"];
    isMobile: boolean;
};

export const getActionPlanHistogramData = (options: Options): DataPoint[] => {
    const { start, current, end, isMobile } = options;
    const data: DataPoint[] = [];
    const currentPoint: DataPoint | undefined =
        current && current.value !== null && current.year !== start.year && current.year !== end.year ?
            { label: current.year, value: current.value, shape: "solid", withComparison: !isMobile }
        :   undefined;
    const isCurrentBeforeStart = current !== undefined && parseInt(current.year, 10) < parseInt(start.year, 10);

    if (currentPoint && isCurrentBeforeStart) {
        data.push(currentPoint);
    }
    if (start.value !== null) {
        data.push({ label: start.year, value: start.value, shape: "solid", withComparison: true });
    }
    if (currentPoint && !isCurrentBeforeStart) {
        data.push(currentPoint);
    }
    if (end.value !== null) {
        data.push({ label: end.year, value: end.value, shape: "dotted" });
    }
    return data;
};
